import React, { PropTypes } from 'react'
import { IssuerLogos, BrandLogos } from '../../images'
export const ApplicationListItemImageEntry = (props) => {
  const {title, value} = props
  const { Header } = props.components
  const brandLogo = value && BrandLogos[value.toLowerCase()]
  let appCardInfo;

  if (IssuerLogos[value]) {
    appCardInfo = <img src={IssuerLogos[value]} alt="value" styleName="app-card__logo" />
  } else if (value && brandLogo) {
    const link = brandLogo.display_text_link
    const text = brandLogo.display_text
    appCardInfo = link ? <a href={link} target="_blank">{text}</a> : text
  }
  return(
    <div styleName="app-card__group-split">
      <Header />
      <div styleName="app-card__info">
        {appCardInfo}
      </div>
    </div>
  )
}
